var map = {
	"./audio-muted.svg": 3583,
	"./audio.svg": 1586,
	"./copy.svg": 6737,
	"./github.svg": 9087,
	"./language.svg": 2945,
	"./video-muted.svg": 1076,
	"./video.svg": 1965
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2007;